module.exports = __webpack_public_path__ + "img/sharp.dbfb53c4.svg";